import { HttpClient, HttpContext, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IS_SHOW_LOADER } from '../../lib/custom-context';

@Injectable({
  providedIn: 'root'
})
export class MasterdataService {
  clientId :any;

  constructor(private http: HttpClient) {
    this.clientId = this.getClientId()
  }
  //  *---------------Masterdata Business Unit-----------------*
  getClientId(): string | null {
    this.clientId = localStorage.getItem('selectedClientId');
    return this.clientId
  }
  getLegalEntityList(body, is_export: boolean = false) {
    this.getClientId()
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `master/v1/legal-entity/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `master/v1/legal-entity/list`, body);
    }
  }
  postLegalEntity(body: {}) {
    this.getClientId()
    return this.http.post(environment.baseApiUrl + `master/v1/legal-entity?client_id=${this.clientId}`, body);
  }
  deleteLegalEntity(id) {
    this.getClientId()
    return this.http.delete(environment.baseApiUrl + `master/v1/legal-entity/${id}?client_id=${this.clientId}`);
  }
  updateLegalEntity(body: {}, id) {
    this.getClientId()
    return this.http.put(environment.baseApiUrl + `master/v1/legal-entity/${id}?client_id=${this.clientId}`, body);
  }

  //  *---------------Masterdata Country-----------------*
  getCountryList(body, is_export: boolean = false) {
    this.getClientId()
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `common/v1/country/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `common/v1/country/list`, body);
    }
  }
  getStateList(country_name) {
    this.getClientId()
    return this.http.get(environment.baseApiUrl + `common/v1/states/by-country/${country_name}`);
  }
  getCityList(country_name, state_name) {
    this.getClientId()
    return this.http.get(environment.baseApiUrl + `common/v1/cities/by-country/${country_name}/by-state/${state_name}`);
  }
  postCountry(body: {}) {
    this.getClientId()
    return this.http.post(environment.baseApiUrl + `common/v1/country`, body);
  }
  deleteCountry(id) {
    this.getClientId()
    return this.http.delete(environment.baseApiUrl + `common/v1/country/${id}`);
  }
  updateCountry(body: {}, id) {
    this.getClientId()
    return this.http.put(environment.baseApiUrl + `common/v1/country/${id}`, body);
  }

  //  *---------------Masterdata PO-----------------*
  getPoList(body, is_export: boolean = false) {
    this.getClientId()
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `master/v1/po/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `master/v1/po/list`, body);
    }
  }
  postpo(body: {}) {
    this.getClientId()
    return this.http.post(environment.baseApiUrl + `master/v1/po?client_id=${this.clientId}`, body);
  }
  deletepo(id) {
    this.getClientId()
    return this.http.delete(environment.baseApiUrl + `master/v1/po/${id}?client_id=${this.clientId}`);
  }
  updatepo(body: {}, id) {
    this.getClientId()
    return this.http.put(environment.baseApiUrl + `master/v1/po/${id}?client_id=${this.clientId}`, body);
  }

  //  *---------------Masterdata PO Item-----------------*
  getPoItemList(body, is_export: boolean = false) {
    this.getClientId()
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `master/v1/purchase-order-item/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `master/v1/purchase-order-item/list`, body);
    }
  }
  postpoItem(body: {}) {
    this.getClientId()
    return this.http.post(environment.baseApiUrl + `master/v1/purchase-order-item?client_id=${this.clientId}`, body);
  }
  deletepoItem(id) {
    this.getClientId()
    return this.http.delete(environment.baseApiUrl + `master/v1/purchase-order-item/${id}?client_id=${this.clientId}`);
  }
  updatepoItem(body: {}, id) {
    this.getClientId()
    return this.http.put(environment.baseApiUrl + `master/v1/purchase-order-item/${id}?client_id=${this.clientId}`, body);
  }

  //  *---------------Masterdata Shipment-----------------*
  getShipmentList(body, is_export: boolean = false) {
    this.getClientId()
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `master/v1/shipment/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `master/v1/shipment/list`, body);
    }
  }
  postShipment(body: {}) {
    this.getClientId()
    return this.http.post(environment.baseApiUrl + `master/v1/shipment?client_id=${this.clientId}`, body);
  }
  deleteShipment(id) {
    this.getClientId()
    return this.http.delete(environment.baseApiUrl + `master/v1/shipments/${id}?client_id=${this.clientId}`);
  }
  updateShipment(body: {}, id) {
    this.getClientId()
    return this.http.put(environment.baseApiUrl + `master/v1/shipments/${id}?client_id=${this.clientId}`, body);
  }

  //  *---------------Masterdata Rate Card-----------------*
  getRateCardList(body, is_export: boolean = false) {
    this.getClientId()
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `master/v1/rate-card/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `master/v1/rate-card/list`, body);
    }
  }
  getRateCardById(id) {
    this.getClientId()
    return this.http.get<any>(environment.baseApiUrl + `master/v1/rate-card/${id}?client_id=${this.clientId}`);
  }
  postRateCard(body: {}) {
    this.getClientId()
    return this.http.post(environment.baseApiUrl + `master/v1/rate-card?client_id=${this.clientId}`, body);
  }
  deleteRateCard(id) {
    this.getClientId()
    return this.http.delete(environment.baseApiUrl + `master/v1/rate-card/${id}?client_id=${this.clientId}`);
  }
  updateRateCard(body: {}, id) {
    this.getClientId()
    return this.http.put(environment.baseApiUrl + `master/v1/rate-card/${id}?client_id=${this.clientId}`, body);
  }



  /*Master Date Rate-Card Surcharges Starts here*/
  getRateCardSurchargeList(body, is_export: boolean = false) {
    this.getClientId()
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `master/v1/surcharge/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `master/v1/surcharge/list`, body);
    }
  }

    getSurchargeCodeLibraryList(body, is_export: boolean = false) {
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `master/v1/surcharge-code-library/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `master/v1/surcharge-code-library/list`, body);
    }
  }

  postSurchage(body: {}) {
    this.getClientId()
    return this.http.post(environment.baseApiUrl + `master/v1/surcharge?client_id=${this.clientId}`, body);
  }
  deleteSurcharge(id) {
    this.getClientId()
    return this.http.delete(environment.baseApiUrl + `master/v1/surcharge/${id}?client_id=${this.clientId}`);
  }
  updateSurcharge(body: {}, id) {
    this.getClientId()
    return this.http.put(environment.baseApiUrl + `master/v1/surcharge/${id}?client_id=${this.clientId}`, body);
  }
  /*Master Date Rate-Card Surcharges Starts here*/
  postSurchargeCodeList(body: {}) {
    return this.http.post(environment.baseApiUrl + `master/v1/surcharge-code-library/create?client_id=${this.clientId}`, body);
  }
  deleteSurchargeCodeList(id) {
    return this.http.delete(environment.baseApiUrl + `master/v1/surcharge-code-library/${id}?client_id=${this.clientId}`);
  }
  updateSurchargeCodeList(body: {}, id) {
    return this.http.put(environment.baseApiUrl + `master/v1/surcharge-code-library/${id}?client_id=${this.clientId}`, body);
  }

  //  *---------------Masterdata Contract-----------------*
  getContractList(body, is_export: boolean = false) {
    this.getClientId()
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `master/v1/contract/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `master/v1/contract/list`, body);
    }
  }
  postContract(body: {}) {
    this.getClientId()
    return this.http.post(environment.baseApiUrl + `master/v1/contract?client_id=${this.clientId}`, body);
  }
  deleteContract(id) {
    this.getClientId()
    return this.http.delete(environment.baseApiUrl + `master/v1/contract/${id}?client_id=${this.clientId}`);
  }
  updateContract(body: {}, id) {
    this.getClientId()
    return this.http.put(environment.baseApiUrl + `master/v1/contract/${id}?client_id=${this.clientId}`, body);
  }

  //  *---------------Currency Exchange-----------------*
  getCurrencyExchangeList(body, is_export: boolean = false) {
    this.getClientId()
    if (is_export) {
      return this.http.post(environment.baseApiUrl + 'common/v1/currency-exchange/list', body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + 'common/v1/currency-exchange/list', body);
    }
  }

  postCurrencyExchange(body: {}) {
    this.getClientId()
    return this.http.post(environment.baseApiUrl + `common/v1/currency-exchange`, body);
  }
  deleteCurrencyExchange(id) {
    this.getClientId()
    return this.http.delete(environment.baseApiUrl + `common/v1/currency-exchange/${id}`);
  }
  updateCurrencyExchange(body: {}, id) {
    this.getClientId()
    return this.http.put(environment.baseApiUrl + `common/v1/currency-exchange/${id}`, body);
  }

  //  *---------------Masterdata Currency-----------------*
  getCurrencyList(body, is_export: boolean = false) {
    this.getClientId()
    if (is_export) {
      return this.http.post(environment.baseApiUrl + 'common/v1/currency/list', body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + 'common/v1/currency/list', body);
    }
  }
  postCurrency(body: {}) {
    this.getClientId()
    return this.http.post(environment.baseApiUrl + `common/v1/currency`, body);
  }
  deleteCurrency(id) {
    this.getClientId()
    return this.http.delete(environment.baseApiUrl + `common/v1/currency/${id}`);
  }
  updateCurrency(body: {}, id) {
    this.getClientId()
    return this.http.put(environment.baseApiUrl + `common/v1/currency/${id}`, body);
  }

  /*-------  Currency-alias  -------*/
  getCurrencyAliasList(body, is_export: boolean = false) {
    this.getClientId()
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `common/v1/currency-alias/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `common/v1/currency-alias/list`, body);
    }
  }
  postCurrencyAlias(body: {}) {
    this.getClientId()
    return this.http.post(environment.baseApiUrl + `common/v1/currency-alias?client_id=${this.clientId}`, body);
  }
  deleteCurrencyAlias(id) {
    this.getClientId()
    return this.http.delete(environment.baseApiUrl + `common/v1/currency-alias/${id}?client_id=${this.clientId}`);
  }
  updateCurrencyAlias(body: {}, id) {
    this.getClientId()
    return this.http.put(environment.baseApiUrl + `common/v1/currency-alias/${id}?client_id=${this.clientId}`, body);
  }

  /*---------  company-name-alias ----------*/
  getCompanyNameAliasList(body, is_export: boolean = false) {
    this.getClientId()
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `common/v1/name-alias/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `common/v1/name-alias/list`, body);
    }
  }
  postCompanyNameAlias(body: {}) {
    this.getClientId()
    return this.http.post(environment.baseApiUrl + `common/v1/name-alias?client_id=${this.clientId}`, body);
  }
  deleteCompanyNameAlias(id) {
    this.getClientId()
    return this.http.delete(environment.baseApiUrl + `common/v1/name-alias/${id}?client_id=${this.clientId}`);
  }
  updateCompanyNameAlias(body: {}, id) {
    this.getClientId()
    return this.http.put(environment.baseApiUrl + `common/v1/name-alias/${id}?client_id=${this.clientId}`, body);
  }

  /*---------  zip-alias ----------*/
  getZipAliasList(body, is_export: boolean = false) {
    this.getClientId()
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `common/v1/zip-alias/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `common/v1/zip-alias/list`, body);
    }
  }
  postZipAlias(body: {}) {
    this.getClientId()
    return this.http.post(environment.baseApiUrl + `common/v1/zip-alias?client_id=${this.clientId}`, body);
  }
  deleteZipAlias(id) {
    this.getClientId()
    return this.http.delete(environment.baseApiUrl + `common/v1/zip-alias/${id}?client_id=${this.clientId}`);
  }
  updateZipAlias(body: {}, id) {
    this.getClientId()
    return this.http.put(environment.baseApiUrl + `common/v1/zip-alias/${id}?client_id=${this.clientId}`, body);
  }


  /*---------  city-alias ----------*/
  getCityAliasList(body, is_export: boolean = false) {
    this.getClientId()
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `common/v1/city-alias/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `common/v1/city-alias/list`, body);
    }
  }
  postCityAlias(body: {}) {
    this.getClientId()
    return this.http.post(environment.baseApiUrl + `common/v1/city-alias?client_id=${this.clientId}`, body);
  }
  deleteCityAlias(id) {
    this.getClientId()
    return this.http.delete(environment.baseApiUrl + `common/v1/city-alias/${id}?client_id=${this.clientId}`);
  }
  updateCityAlias(body: {}, id) {
    this.getClientId()
    return this.http.put(environment.baseApiUrl + `common/v1/city-alias/${id}?client_id=${this.clientId}`, body);
  }

  /*---------  city-alias ----------*/
  getVatAliasList(body, is_export: boolean = false) {
    this.getClientId()
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `common/v1/vat-alias/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `common/v1/vat-alias/list`, body);
    }
  }
  postVatAlias(body: {}) {
    this.getClientId()
    return this.http.post(environment.baseApiUrl + `common/v1/vat-alias?client_id=${this.clientId}`, body);
  }
  deleteVatAlias(id) {
    this.getClientId()
    return this.http.delete(environment.baseApiUrl + `common/v1/vat-alias/${id}?client_id=${this.clientId}`);
  }
  updateVatAlias(body: {}, id) {
    this.getClientId()
    return this.http.put(environment.baseApiUrl + `common/v1/vat-alias/${id}?client_id=${this.clientId}`, body);
  }

  //  *---------------Masterdata Service Type-----------------*
  getServiceTypeList(body, is_export: boolean = false) {
    this.getClientId()
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `master/v1/charge-type/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `master/v1/charge-type/list`, body);
    }
  }
  getSingleServiceType(id) {
    this.getClientId()
      return this.http.get<any>(environment.baseApiUrl + `master/v1/charge-type/${id}?client_id=${this.clientId}`);
  }
  postServiceType(body: {}) {
    this.getClientId()
    return this.http.post(environment.baseApiUrl + `master/v1/charge-type?client_id=${this.clientId}`, body);
  }
  deleteServiceType(id) {
    this.getClientId()
    return this.http.delete(environment.baseApiUrl + `master/v1/charge-type/${id}?client_id=${this.clientId}`);
  }
  updateServiceType(body: {}, id) {
    this.getClientId()
    return this.http.put(environment.baseApiUrl + `master/v1/charge-type/${id}?client_id=${this.clientId}`, body);
  }

  // master data uom

  getUOMList(body, is_export: boolean = false) {
    this.getClientId()
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `master/v1/uom/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `master/v1/uom/list`, body);
    }
  }
  postUOM(body: {}) {
    this.getClientId()
    return this.http.post(environment.baseApiUrl + `master/v1/uom?client_id=${this.clientId}`, body);
  }
  deleteUOM(id) {
    this.getClientId()
    return this.http.delete(environment.baseApiUrl + `master/v1/uom/${id}?client_id=${this.clientId}`);
  }
  updateUOM(body: {}, id) {
    this.getClientId()
    return this.http.put(environment.baseApiUrl + `master/v1/uom/${id}?client_id=${this.clientId}`, body);
  }

  // master data sector

  getSectorList(body, is_export: boolean = false) {
    this.getClientId()
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `master/v1/sector/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `master/v1/sector/list`, body);
    }
  }
  postSector(body: {}) {
    this.getClientId()
    return this.http.post(environment.baseApiUrl + `master/v1/sector?client_id=${this.clientId}`, body);
  }
  deleteSector(id) {
    this.getClientId()
    return this.http.delete(environment.baseApiUrl + `master/v1/sector/${id}?client_id=${this.clientId}`);
  }
  updateSector(body: {}, id) {
    this.getClientId()
    return this.http.put(environment.baseApiUrl + `master/v1/sector/${id}?client_id=${this.clientId}`, body);
  }
  getTransportList(body, is_export: boolean = false) {
    this.getClientId()
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `master/v1/transport-mode/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `master/v1/transport-mode/list`, body);
    }
  }
   getPortList(body, is_export: boolean = false, showLoader: boolean = true) {
    this.getClientId()
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `master/v1/port/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `master/v1/port/list`, body, {
        context: new HttpContext().set(IS_SHOW_LOADER, showLoader)
      });
    }
  }
   getContainer(body, is_export: boolean = false) {
    this.getClientId()
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `master/v1/container-type-size/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `master/v1/container-type-size/list`, body);
    }
  }
   getChargeTypeList(body, is_export: boolean = false) {
    this.getClientId()
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `master/v1/charge-type/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `master/v1/charge-type/list`, body);
    }
  }

  getShortInfoCustomer(body) {
    this.getClientId()
    return this.http.get(environment.baseApiUrl + `master/v1/short-info/customers/${this.clientId}`,body);
  }
  getShortInfoSBU(customer_id) {
    this.getClientId()
    return this.http.get(environment.baseApiUrl + `master/v1/short-info/sbus/${customer_id}/${this.clientId}`);
  }
  getShortInfoVendor(body) {
    this.getClientId()
    return this.http.get(environment.baseApiUrl + `master/v1/short-info/vendors/${this.clientId}`,body);
  }
}
